module.exports = __webpack_public_path__ + "static/media/3-1-kanimate20kg.c0a6f32f.jpg";